import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../utils/api';
import { CheckCircle, ArrowRight } from 'lucide-react';
import Header from '../components/Header';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const [checking, setChecking] = useState(true);
  const [verified, setVerified] = useState(false);
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    verifyPayment();
  }, [sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  const verifyPayment = async () => {
    if (!sessionId) {
      navigate('/consultations');
      return;
    }

    let attempts = 0;
    const maxAttempts = 10;

    const checkStatus = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') {
          setVerified(true);
          setChecking(false);
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkStatus, 2000);
        } else {
          setChecking(false);
        }
      } catch (error) {
        setChecking(false);
      }
    };

    checkStatus();
  };

  return (
    <div style={{ backgroundColor: '#FDFBF7', minHeight: '100vh' }}>
      <Header />
      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        {checking ? (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 mx-auto mb-8" style={{ borderColor: '#E57A44' }}></div>
            <h2 className="text-2xl font-semibold mb-4" style={{ fontFamily: 'Merriweather, serif', color: '#2C2A29' }}>Confirming your payment...</h2>
          </>
        ) : verified ? (
          <>
            <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-8" style={{ backgroundColor: '#78A18E20' }}>
              <CheckCircle className="w-12 h-12" style={{ color: '#78A18E', strokeWidth: 2 }} />
            </div>
            <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Merriweather, serif', color: '#2C2A29' }}>Payment Successful!</h1>
            <p className="text-lg mb-8" style={{ fontFamily: 'Nunito, sans-serif', color: '#595553' }}>
              Your consultation request has been submitted. You'll receive a personalized response soon!
            </p>
            <button
              onClick={() => navigate('/consultations')}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full transition-all duration-300 hover:-translate-y-1"
              style={{ fontFamily: 'Nunito, sans-serif', backgroundColor: '#E57A44', color: '#FDFBF7', fontWeight: 600 }}
              data-testid="view-consultations"
            >
              <span>View Your Consultations</span>
              <ArrowRight className="w-5 h-5" />
            </button>
          </>
        ) : (
          <>
            <h1 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Merriweather, serif', color: '#2C2A29' }}>Payment Processing</h1>
            <p className="text-lg mb-8" style={{ fontFamily: 'Nunito, sans-serif', color: '#595553' }}>
              Your payment is being processed. Please check your consultations in a few moments.
            </p>
            <button
              onClick={() => navigate('/consultations')}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full transition-all duration-300 hover:-translate-y-1"
              style={{ fontFamily: 'Nunito, sans-serif', backgroundColor: '#E57A44', color: '#FDFBF7', fontWeight: 600 }}
            >
              <span>Go to Consultations</span>
              <ArrowRight className="w-5 h-5" />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
